import { motion } from "framer-motion";
import { Star, ExternalLink, PenLine } from "lucide-react";
import { Chapter } from "@/components/landing/Chapter";

const MAPS_URL = "https://share.google/GaxtXtyIzkjg8BuGi";

export const Avis = () => (
  <section id="avis" data-testid="avis-section" className="relative py-24 lg:py-36 bg-[#0A0D16] border-y border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Chapter num="04" title="Avis Google" accent="Ils nous font confiance" />

      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5 rounded-md border border-white/10 bg-[#0E1322] p-10 text-center relative overflow-hidden"
        >
          <div className="absolute -top-16 -right-16 w-48 h-48 bg-[#0066FF]/15 blur-3xl rounded-full pointer-events-none" />
          <div className="font-mono-tech text-xs uppercase tracking-[0.3em] text-slate-400">Note Google</div>
          <div data-testid="avis-google-rating" className="font-display font-extrabold text-7xl md:text-8xl tracking-tighter mt-4">
            5,0
          </div>
          <div className="flex justify-center gap-1.5 mt-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-6 h-6 fill-[#FBBF24] text-[#FBBF24]" />
            ))}
          </div>
          <p className="text-sm text-slate-400 mt-5 leading-relaxed">
            Note maximale — 8 avis Google — pour l'accueil, la qualité des réparations
            et la transparence des devis.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight">
            Votre confiance, notre meilleure publicité.
          </h3>
          <p className="text-base text-slate-300 leading-relaxed mt-5 max-w-xl">
            Chaque avis compte. Consultez les retours de nos clients sur Google et,
            si vous êtes passé à l'atelier, partagez votre expérience : cela aide
            les automobilistes du pays d'Oyonnax à choisir un garage de confiance.
          </p>
          <div className="mt-9 flex flex-wrap gap-4">
            <a
              data-testid="avis-voir-google-button"
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-[#0066FF] hover:bg-[#0052CC] text-white font-semibold px-7 py-3.5 flex items-center gap-2 transition-[background-color,box-shadow,transform] duration-300 hover:shadow-[0_0_28px_rgba(0,102,255,0.5)] hover:-translate-y-0.5"
            >
              Voir les avis sur Google
              <ExternalLink className="w-4 h-4" />
            </a>
            <a
              data-testid="avis-laisser-avis-button"
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full border border-white/20 hover:border-[#FBBF24] text-white font-semibold px-7 py-3.5 flex items-center gap-2 transition-[border-color,background-color] duration-300 hover:bg-[#FBBF24]/10"
            >
              <PenLine className="w-4 h-4" />
              Laisser un avis
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
